import { SentProformaEmployeeCostReportDTO } from "src/models/sent-proforma-employee-cost-report/sent-proforma-employee-cost-report-dto";
import { BaseApiService } from "../base";
import { SentProformaEmployeeCostReportSTO } from "src/models/sent-proforma-employee-cost-report/sent-proforma-employee-cost-report-sto";
import { ListSortDirection } from "src/models/api/sort";

export class SendProformaEmployeeCostReportApiService extends BaseApiService<
  SentProformaEmployeeCostReportDTO,
  SentProformaEmployeeCostReportSTO
> {
  constructor() {
    super({
      servicePath: "/SentProformaEmployeeCostReport",
      loadItemsPath: "/GetSentProformaEmployeeCostReports",
      saveItemsPath: "/SendProformaEmployeeCostReport",
    });
  }
}
